export default "https://cdn-static.gokick.com/assets/3c8eadbe8dc90fc8bfe5d2560afe7db765946837/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";